import { Language, Subsidiary } from '@coolblue-development/constants';
import { formatCurrency } from '@coolblue-development/next-formatting-utils/core';

import { LeaseTerm } from './Context';

export const getLongestLeaseTermId = (leaseTerms: LeaseTerm[] | null): string | null => {
  if (!leaseTerms || leaseTerms.length === 0) return null;

  const longestLeaseTerm = leaseTerms.reduce((longest, current) =>
    current.duration > longest.duration ? current : longest
  );

  return longestLeaseTerm.id;
};

export const getLowestLeaseTermAmount = (leaseTerms: LeaseTerm[] | 0): number => {
  if (!leaseTerms || leaseTerms.length === 0) return 0;

  const lowestLeaseTerm = leaseTerms.reduce((lowest, current) =>
    current.monthlyAmount < lowest.monthlyAmount ? current : lowest
  );

  return lowestLeaseTerm.monthlyAmount;
};

export const formatPrice = (price: number) => {
  return formatCurrency({
    amount: price,
    language: Language.DUTCH,
    subsidiary: Subsidiary.NL
  })
    .replace(',00', ',-')
    .substring(2);
};
